// // components/ProtectedRoute.tsx
// import React from "react";
// import { Navigate, useLocation } from "react-router-dom";

// const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
//   const accessToken = localStorage.getItem("accessToken");
//   const leadId = localStorage.getItem("lead_profile_id");
//   const isLoggedIn = !!accessToken && !!leadId;
//   const location = useLocation();

//   return isLoggedIn ? (
//     children
//   ) : (
//     <Navigate
//       to="/onbording3"
//       replace
//       state={{ from: location.pathname }}
//     />
//   );
// };

// export default ProtectedRoute;

// components/ProtectedRoute.tsx
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const accessToken = localStorage.getItem("accessToken");
  const leadId = localStorage.getItem("lead_profile_id") ?? "";

  const isLoggedIn = !!accessToken && !!leadId;

  return isLoggedIn ? children : <Navigate to="/onbording3" replace />;
};

export default ProtectedRoute;
